import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["swiper-slide pin-item my-auto w-full shrink-0 transition-all duration-[350ms] ease-in-out first:ml-0 lg:ml-0 lg:duration-[20ms] lg:ease-linear last:lg:rotate-0", {
            'lg:absolute lg:left-1/2 lg:top-1/2 lg:w-145 lg:-translate-x-1/2 lg:-translate-y-1/2 lg:opacity-0':
                !_ctx.editMode,
            'lg:rotate-1': _ctx.rotation === 1,
            'lg:-rotate-1': _ctx.rotation === -1,
            'lg:rotate-2': _ctx.rotation === 2,
            'lg:-rotate-2': _ctx.rotation === -2,
            'lg:rotate-3': _ctx.rotation === 3,
            'lg:-rotate-3': _ctx.rotation === -3
        }])
      }, [
        _renderSlot(_ctx.$slots, "default", { active: _ctx.active })
      ], 2))
    : _createCommentVNode("", true)
}